import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/forgotPasswordModal";
import deltas from "../../actions/deltas";

const {SET_FORGOT_PASSWORD_MODAL_STATE} = deltas.actionTypes;

export default createStateReducer(states, states.CLOSED, SET_FORGOT_PASSWORD_MODAL_STATE);
